module.exports = __webpack_public_path__ + "img/1728877612716-WIN_20241014_11_45_17_Pro.jpg.e974d49e.webp";